module.exports = __webpack_public_path__ + "static/media/FetsLogo.cc744cdc.png";